export class WorkSpaceSerializedPanel {
    name: string;
    properties: any;
    xmlSettingsTemplate: any;
}
